import { render, staticRenderFns } from "./PropertyDangerousSituations.vue?vue&type=template&id=40cbdc58&scoped=true"
import script from "./PropertyDangerousSituations.vue?vue&type=script&lang=js"
export * from "./PropertyDangerousSituations.vue?vue&type=script&lang=js"
import style0 from "./PropertyDangerousSituations.vue?vue&type=style&index=0&id=40cbdc58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbdc58",
  null
  
)

export default component.exports